import React from "react";
import css from './SurveyNotFound.css';
import Button from 'common/StyledButton';
import { SFSurveysTenantLanguage } from "utils/types";

export default class SurveyNotFound extends React.Component {
  get back() {
    return (
      <Button
        onClick={() => {
          window.location.href = `#survey/`;
        }}
        className={css['button']}>
        {`View my ${this.props.progressSurveyWords.plural.surveys}`}
      </Button>
    );
  }
  render() {
    return (
      <div className={css['container']}>
        <img src="../images/alert.svg" />
        <h1>Oops! Something went wrong...</h1>
        <p>
          {`The link you clicked is not a valid ${this.props.progressSurveyWords.singular.survey}. It may be unavailable or expired.`}
        </p>
        {this.back}
      </div>
    );
  }
}

SurveyNotFound.propTypes = {
  progressSurveyWords: SFSurveysTenantLanguage
};

